module.exports = __webpack_public_path__ + "static/media/requests.81574523.svg";